import {
  Route, BrowserRouter as Router, Switch, Redirect
} from "react-router-dom";
import { Container } from "react-bootstrap";

import Inicio from "./paginas/Inicio";
import DesarrolloWeb from "./paginas/DesarrolloWeb";
import Applicaciones from "./paginas/Applicaciones";
import Logo from "./paginas/Logo";
// import CursorCirculo from "./componentes/CursorCirculo";

function App() {
  return (
    <Container fluid>
      {/* <CursorCirculo /> */}
      <Router>
        <Switch>
          <Route path="/inicio" exact>
            <Inicio />
          </Route>
          <Route path="/desarrollo-web" exact>
            <DesarrolloWeb />
          </Route>
          <Route path="/app" exact>
            <Applicaciones />
          </Route>
          <Route path="/logo" exact>
            <Logo />
          </Route>
          <Redirect to="inicio"/>
        </Switch>
      </Router>
    </Container>
  );
}

export default App;
